var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero'),_c('v-container',{staticClass:"py-5 px-0",attrs:{"fluid":""}},[_c('About'),_c('Possibility'),_c('Experience'),_c('Skills'),_c('Portfolio'),_c('Contact')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }